import { callFetch, header } from './utils';

const EndPoint = {
  GetOccpations: () => `/line/occupation-list`,
  GetLocation: () => `/line/location-list`,
};

export function getOccpations() {
  const uri = EndPoint.GetOccpations();
  let settings = {
    method: 'GET',
    headers: { ...header },
  };

  return callFetch(uri, settings);
}
export function getLocations() {
  const uri = EndPoint.GetLocation();
  let settings = {
    method: 'GET',
    headers: { ...header },
  };

  return callFetch(uri, settings);
}
